import { render, staticRenderFns } from "./LongTextFormItem.vue?vue&type=template&id=52da6e75&scoped=true&"
import script from "./LongTextFormItem.vue?vue&type=script&lang=js&"
export * from "./LongTextFormItem.vue?vue&type=script&lang=js&"
import style0 from "./LongTextFormItem.vue?vue&type=style&index=0&id=52da6e75&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../.jenkins/workspace/DMSDashboardDeployLIVE/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52da6e75",
  null
  
)

export default component.exports